import React, { useState } from 'react';
import { ChartNoAxesColumnIncreasing, ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { VIcon } from '../keno/VCredit';
import { originalGames } from '../originals/games';

export const formatProfileWager = (minor) => {
  const value = BigInt(minor);
  return `${(value / 100n).toLocaleString('en-US')}.${(value % 100n).toString().padStart(2, '0')}`;
};

export const ProfileGameWagers = ({ wagers, prefix }) => {
  const [open, setOpen] = useState(false);
  return <Collapsible open={open} onOpenChange={setOpen} className="profile-game-wagers" data-testid={`${prefix}-game-wagers`}>
    <CollapsibleTrigger className="profile-wagers-trigger" data-testid={`${prefix}-game-wagers-toggle`}>
      <ChartNoAxesColumnIncreasing size={17} aria-hidden="true" /><span>Amounts wagered by game</span><ChevronDown size={17} aria-hidden="true" />
    </CollapsibleTrigger>
    <CollapsibleContent data-testid={`${prefix}-game-wagers-content`}>
      <p className="profile-wagers-caption" data-testid={`${prefix}-game-wagers-caption`}>Lifetime · Settled bets</p>
      <dl className="profile-wagers-list" data-testid={`${prefix}-game-wagers-list`}>
        {originalGames.filter((game) => game.available).map((game) => {
          const total = wagers?.find((item) => item.game === game.id);
          const amount = total ? formatProfileWager(total.wagered_minor) : null;
          return <div key={game.id} className="profile-wagers-row" data-testid={`${prefix}-game-wagers-${game.id}`}>
            <dt data-testid={`${prefix}-game-wagers-${game.id}-name`}>{game.name}</dt>
            <dd data-testid={`${prefix}-game-wagers-${game.id}-amount`} title={amount ? `${amount} V credits` : undefined}>
              {amount !== null && <VIcon testid={`${prefix}-game-wagers-${game.id}-icon`} />}<span>{amount ?? 'Unavailable'}</span>
            </dd>
          </div>;
        })}
      </dl>
    </CollapsibleContent>
  </Collapsible>;
};